import { render, staticRenderFns } from "./NotificationsQueue.vue?vue&type=template&id=4fe89d1a"
import script from "./NotificationsQueue.vue?vue&type=script&lang=js"
export * from "./NotificationsQueue.vue?vue&type=script&lang=js"
import style0 from "./NotificationsQueue.vue?vue&type=style&index=0&id=4fe89d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports